<!-- Spinner while statuses are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the API key list. Click below try again.
    <button hc-button size="lg" (click)="loadKeys()">Reload Keys</button>
</div>

<div class="admin-keys-table-container" [hidden]="loadError || loading">
    <h2> <hc-icon fontSet="fa" fontIcon="fa-key"></hc-icon> API Keys </h2>
    <table hc-table [borders]="false" class="admin-keys-table" [dataSource]="dataSource" hcSort>
        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Value Column -->
        <ng-container hcColumnDef="value">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="valueHeader">Key</th>
            <td hc-cell *hcCellDef="let element" [innerHTML]="element.value"></td>
        </ng-container>

        <!-- Username Column -->
        <ng-container hcColumnDef="username">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="usernameHeader">User</th>
            <td hc-cell *hcCellDef="let element" [innerHTML]="element.username"></td>
        </ng-container>

        <!-- Date Column -->
        <ng-container hcColumnDef="date">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="dateHeader">Date Generated</th>
            <td hc-cell *hcCellDef="let element" [innerHTML]="element.date | date:'shortDate'"></td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center"> 
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span hcMenuIcon class="fa fa-trash hc-action-ico" hcTooltip="Remove key" (click)="removeKey(element)"></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminKeysDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminKeysDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No API keys have been generated.</span>
    </div>

    <hc-pagination
        [length]="adminKeysListLength"
        [pageSize]="adminKeysPageSize"
        [hidden]="loadError || loading"
    ></hc-pagination>
</div>